export const DummyMarchInCart = [
  {
    id: '659c1ede60616d69e4258c46',
    code: 'SDM24_CATALOGO',
    description: 'Catalogo generale 2024',
    kind: null,
    category: [],
    status: 'enabled',
    deletable: null,
    template: 'SDM23_CATALOGO',
    titled: false,
    area: {
      id: '60ecbd007c8f3f63ae231684',
      code: 'default',
      description: 'Area Default',
      blame_operator_id: null,
      read_only: false,
      count_result: null,
    },
    prices: [
      {
        id: '659c1f2860616d69e4258c47',
        value: 50,
        discount: 0,
        currency: null,
        blame_operator_id: '65705edec2487079ea0bb0ec',
        read_only: false,
        count_result: null,
        start_date: '2024-01-02',
        end_date: '2024-04-21',
        product_id: '659c1ede60616d69e4258c46',
        channel_id: '64776ad011b1421bf7546fff',
        presales_amount: 0,
      },
    ],
    duration: null,
    capacity: null,
    blame_operator_id: null,
    read_only: false,
    count_result: null,
    display_code: 'CA2',
    kind_special: ['end_user', 'operator', 'school'],
    kind_description:
      "Catalogo generale Salone del Mobile.Milano 2023: (Salone del Mobile, Salone del complemento d'arredo, Workplace 3.0, S.Project, Euroluce)",
    template_title: null,
    description_map: {
      it: 'Catalogo generale 2024',
      en: 'General catalogue 2024',
    },
    kind_description_map: {
      it: "Catalogo generale Salone del Mobile.Milano 2023: (Salone del Mobile, Salone del complemento d'arredo, Workplace 3.0, S.Project, Euroluce)",
      en: 'General catalogue 2023 Salone del Mobile.Milano: (Salone del Mobile, Furnishing accessories exhibition, Workplace 3.0, S.Project, Euroluce)',
    },
    template_title_map: {
      it: null,
      en: null,
    },
    product_type: 'merchandising',
    siae_domain: false,
    group_type_code: null,
    current_price: 50,
    current_presales_amount: 0,
    competence_date: null,
    area_id: '60ecbd007c8f3f63ae231684',
    related_products: [],
    bank_account_id: null,
    configurable_id: null,
    transit_from: null,
    transit_to: null,
    access_state_enabled: null,
    access_fiscality_executed_once: null,
    group_type: null,
    group_type_id: null,
    sell_limit: null,
    merch_stock: 999992,
    merch_max_limit: 9999999,
    customer_merch_limit: null,
    position: 1,
    salable: null,
    pdf_template_id: null,
    pdf_template_upload_snap: null,
    emission_organizer_name: null,
    emission_organizer_fiscal_code: null,
    product_images: null,
    max_number_of_assignments: null,
    profiling_category: null,
    enable_lead: null,
    enable_entrance_sms: null,
    linked_form_name: null,
    visual_description: null,
    max_tickets_for_enabled_owner: null,
    holder_email_template_map: {
      it: null,
      en: null,
    },
    invitation_email_template_map: {
      it: null,
      en: null,
    },
    skip_reservation_check_to_entrance: null,
    quantity: 1,
    isMerchandising: true,
  },
];

export const DummyTicketsData = [
  {
    assignData: {
      firstname: 'Pier',
      lastname: 'Baorocci',
      email: 'pier.barocci@nautes.com',
      phone: '393333333333',
      reservations: [
        {
          date: '2024-04-16',
          groupCodes: ['aae6a03b-b4f5-46d6-89ca-5e280c565b95'],
          areaCode: 'OPE',
          selected: false,
        },
        {
          date: '2024-04-17',
          groupCodes: ['81066556-1352-4760-8fcb-2847f939f765'],
          areaCode: 'OPE',
          selected: false,
        },
        {
          date: '2024-04-18',
          groupCodes: ['cb914224-b289-4275-bc2e-efe1c8383d96'],
          areaCode: 'OPE',
          selected: false,
        },
        {
          date: '2024-04-19',
          groupCodes: ['2616e2a8-4ee4-4d8e-96a9-49dd6af9dae8'],
          areaCode: 'OPE',
          selected: false,
        },
        {
          date: '2024-04-20',
          groupCodes: ['41687d9f-ee23-443e-843e-c8e8df1b97fc'],
          areaCode: 'OPE',
          selected: false,
        },
        {
          date: '2024-04-21',
          groupCodes: ['7c8b5fac-8f83-4c20-94d3-59795dc442c9'],
          areaCode: 'OPE',
          selected: false,
        },
      ],
      owner_flag_privacy_1: '1',
      owner_flag_privacy_2: '0',
      owner_flag_privacy_3: '0',
      country: {
        value: 'ITA',
        label: 'Italia',
      },
      city: {
        value: 'Jesi',
        label: 'Jesi',
      },
      company: 'Nautes',
      sdm_role_in_company: 1001,
      sdm_operator_type: 'acq',
      sendToThisEmail: '',
    },
    ticketData: {
      id: '6486ef1fad9910072dc33e08',
      code: 'SDM24_OPE_6_PVOK',
      description: 'Biglietto Operatore 6 giorno - Prevendita',
      kind: 'ridotto',
      category: [],
      status: 'enabled',
      deletable: null,
      template: 'SMM_23_E-ticket_OPERATORE_06',
      titled: true,
      area: {
        id: '647869a011b1421bf754701b',
        code: 'OPE',
        description: 'Area operatori definitiva',
        blame_operator_id: '633efa1035c7e1510d218183',
        read_only: false,
        count_result: null,
      },
      prices: [
        {
          id: '6486ef1fad9910072dc33e09',
          value: 73,
          discount: 0,
          currency: 'EUR',
          blame_operator_id: null,
          read_only: false,
          count_result: null,
          start_date: '2023-06-12',
          end_date: '2024-04-21',
          product_id: '6486ef1fad9910072dc33e08',
          channel_id: '64776ad011b1421bf7546fff',
          presales_amount: 0,
        },
      ],
      duration: null,
      capacity: 6,
      blame_operator_id: null,
      read_only: false,
      count_result: null,
      display_code: 'OP6',
      kind_special: ['operator'],
      kind_description:
        'Biglietto per gli Operatori di settore valido 6 giorni. Consente alla persona a cui è intestato un massimo di 2 ingressi in ognuno dei giorni prenotati. Prezzo di prevendita online in vigore fino al 15 Aprile (23.59 CET)',
      template_title: null,
      description_map: {
        it: 'Biglietto Operatore 6 giorno - Prevendita',
        en: '6-Day Trade Visitor Ticket - Presale',
      },
      kind_description_map: {
        it: 'Biglietto per gli Operatori di settore valido 6 giorni. Consente alla persona a cui è intestato un massimo di 2 ingressi in ognuno dei giorni prenotati. Prezzo di prevendita online in vigore fino al 15 Aprile (23.59 CET)',
        en: '6-Day Trade Ticket: Must be made out to the bearer; valid for  a maximum of 2 entries on each of the booked dates. Earlybird online ticket until 15th April (23:59 CET)',
      },
      template_title_map: {
        it: null,
        en: null,
      },
      product_type: 'siae_abbonamento_libero',
      siae_domain: true,
      group_type_code: 'IND',
      current_price: 73,
      current_presales_amount: 0,
      competence_date: null,
      area_id: '647869a011b1421bf754701b',
      related_products: [],
      bank_account_id: null,
      configurable_id: '6486ef1fad9910072dc33e07',
      transit_from: null,
      transit_to: null,
      access_state_enabled: null,
      access_fiscality_executed_once: null,
      group_type: {
        id: '60ec4b037c8f3f63ae23167d',
        code: 'IND',
        description: 'Individuale',
        blame_operator_id: null,
        read_only: false,
        count_result: null,
      },
      group_type_id: '60ec4b037c8f3f63ae23167d',
      sell_limit: null,
      merch_stock: null,
      merch_max_limit: null,
      customer_merch_limit: null,
      position: null,
      salable: null,
      pdf_template_id: null,
      pdf_template_upload_snap: null,
      emission_organizer_name: null,
      emission_organizer_fiscal_code: null,
      product_images: null,
      max_number_of_assignments: null,
      profiling_category: null,
      enable_lead: null,
      enable_entrance_sms: null,
      linked_form_name: '',
      visual_description: null,
      max_tickets_for_enabled_owner: null,
      holder_email_template_map: {
        it: null,
        en: null,
      },
      invitation_email_template_map: {
        it: null,
        en: null,
      },
      skip_reservation_check_to_entrance: null,
      quantity: 2,
    },
  },
  {
    assignData: {
      firstname: 'Nico',
      lastname: 'Nico',
      email: 'nico.nico@nautes.com',
      phone: '393333333333',
      reservations: [
        {
          date: '2024-04-16',
          groupCodes: ['aae6a03b-b4f5-46d6-89ca-5e280c565b95'],
          areaCode: 'OPE',
          selected: false,
        },
        {
          date: '2024-04-17',
          groupCodes: ['81066556-1352-4760-8fcb-2847f939f765'],
          areaCode: 'OPE',
          selected: false,
        },
        {
          date: '2024-04-18',
          groupCodes: ['cb914224-b289-4275-bc2e-efe1c8383d96'],
          areaCode: 'OPE',
          selected: false,
        },
        {
          date: '2024-04-19',
          groupCodes: ['2616e2a8-4ee4-4d8e-96a9-49dd6af9dae8'],
          areaCode: 'OPE',
          selected: false,
        },
        {
          date: '2024-04-20',
          groupCodes: ['41687d9f-ee23-443e-843e-c8e8df1b97fc'],
          areaCode: 'OPE',
          selected: false,
        },
        {
          date: '2024-04-21',
          groupCodes: ['7c8b5fac-8f83-4c20-94d3-59795dc442c9'],
          areaCode: 'OPE',
          selected: false,
        },
      ],
      owner_flag_privacy_1: '1',
      owner_flag_privacy_2: '0',
      owner_flag_privacy_3: '0',
      country: {
        value: 'ITA',
        label: 'Italia',
      },
      city: {
        value: 'Jesi',
        label: 'Jesi',
      },
      company: 'Nautes',
      sdm_role_in_company: 1001,
      sdm_operator_type: 'acq',
      sendToThisEmail: '',
    },
    ticketData: {
      id: '6486ef1fad9910072dc33e08',
      code: 'SDM24_OPE_6_PVOK',
      description: 'Biglietto Operatore 6 giorno - Prevendita',
      kind: 'ridotto',
      category: [],
      status: 'enabled',
      deletable: null,
      template: 'SMM_23_E-ticket_OPERATORE_06',
      titled: true,
      area: {
        id: '647869a011b1421bf754701b',
        code: 'OPE',
        description: 'Area operatori definitiva',
        blame_operator_id: '633efa1035c7e1510d218183',
        read_only: false,
        count_result: null,
      },
      prices: [
        {
          id: '6486ef1fad9910072dc33e09',
          value: 73,
          discount: 0,
          currency: 'EUR',
          blame_operator_id: null,
          read_only: false,
          count_result: null,
          start_date: '2023-06-12',
          end_date: '2024-04-21',
          product_id: '6486ef1fad9910072dc33e08',
          channel_id: '64776ad011b1421bf7546fff',
          presales_amount: 0,
        },
      ],
      duration: null,
      capacity: 6,
      blame_operator_id: null,
      read_only: false,
      count_result: null,
      display_code: 'OP6',
      kind_special: ['operator'],
      kind_description:
        'Biglietto per gli Operatori di settore valido 6 giorni. Consente alla persona a cui è intestato un massimo di 2 ingressi in ognuno dei giorni prenotati. Prezzo di prevendita online in vigore fino al 15 Aprile (23.59 CET)',
      template_title: null,
      description_map: {
        it: 'Biglietto Operatore 6 giorno - Prevendita',
        en: '6-Day Trade Visitor Ticket - Presale',
      },
      kind_description_map: {
        it: 'Biglietto per gli Operatori di settore valido 6 giorni. Consente alla persona a cui è intestato un massimo di 2 ingressi in ognuno dei giorni prenotati. Prezzo di prevendita online in vigore fino al 15 Aprile (23.59 CET)',
        en: '6-Day Trade Ticket: Must be made out to the bearer; valid for  a maximum of 2 entries on each of the booked dates. Earlybird online ticket until 15th April (23:59 CET)',
      },
      template_title_map: {
        it: null,
        en: null,
      },
      product_type: 'siae_abbonamento_libero',
      siae_domain: true,
      group_type_code: 'IND',
      current_price: 73,
      current_presales_amount: 0,
      competence_date: null,
      area_id: '647869a011b1421bf754701b',
      related_products: [],
      bank_account_id: null,
      configurable_id: '6486ef1fad9910072dc33e07',
      transit_from: null,
      transit_to: null,
      access_state_enabled: null,
      access_fiscality_executed_once: null,
      group_type: {
        id: '60ec4b037c8f3f63ae23167d',
        code: 'IND',
        description: 'Individuale',
        blame_operator_id: null,
        read_only: false,
        count_result: null,
      },
      group_type_id: '60ec4b037c8f3f63ae23167d',
      sell_limit: null,
      merch_stock: null,
      merch_max_limit: null,
      customer_merch_limit: null,
      position: null,
      salable: null,
      pdf_template_id: null,
      pdf_template_upload_snap: null,
      emission_organizer_name: null,
      emission_organizer_fiscal_code: null,
      product_images: null,
      max_number_of_assignments: null,
      profiling_category: null,
      enable_lead: null,
      enable_entrance_sms: null,
      linked_form_name: '',
      visual_description: null,
      max_tickets_for_enabled_owner: null,
      holder_email_template_map: {
        it: null,
        en: null,
      },
      invitation_email_template_map: {
        it: null,
        en: null,
      },
      skip_reservation_check_to_entrance: null,
      quantity: 2,
    },
  },
];

export const DummyProductsInCart = [
  {
    id: '6486ef1fad9910072dc33e08',
    code: 'SDM24_OPE_6_PVOK',
    description: 'Biglietto Operatore 6 giorno - Prevendita',
    kind: 'ridotto',
    category: [],
    status: 'enabled',
    deletable: null,
    template: 'SMM_23_E-ticket_OPERATORE_06',
    titled: true,
    area: {
      id: '647869a011b1421bf754701b',
      code: 'OPE',
      description: 'Area operatori definitiva',
      blame_operator_id: '633efa1035c7e1510d218183',
      read_only: false,
      count_result: null,
    },
    prices: [
      {
        id: '6486ef1fad9910072dc33e09',
        value: 73,
        discount: 0,
        currency: 'EUR',
        blame_operator_id: null,
        read_only: false,
        count_result: null,
        start_date: '2023-06-12',
        end_date: '2024-04-21',
        product_id: '6486ef1fad9910072dc33e08',
        channel_id: '64776ad011b1421bf7546fff',
        presales_amount: 0,
      },
    ],
    duration: null,
    capacity: 6,
    blame_operator_id: null,
    read_only: false,
    count_result: null,
    display_code: 'OP6',
    kind_special: ['operator'],
    kind_description:
      'Biglietto per gli Operatori di settore valido 6 giorni. Consente alla persona a cui è intestato un massimo di 2 ingressi in ognuno dei giorni prenotati. Prezzo di prevendita online in vigore fino al 15 Aprile (23.59 CET)',
    template_title: null,
    description_map: {
      it: 'Biglietto Operatore 6 giorno - Prevendita',
      en: '6-Day Trade Visitor Ticket - Presale',
    },
    kind_description_map: {
      it: 'Biglietto per gli Operatori di settore valido 6 giorni. Consente alla persona a cui è intestato un massimo di 2 ingressi in ognuno dei giorni prenotati. Prezzo di prevendita online in vigore fino al 15 Aprile (23.59 CET)',
      en: '6-Day Trade Ticket: Must be made out to the bearer; valid for  a maximum of 2 entries on each of the booked dates. Earlybird online ticket until 15th April (23:59 CET)',
    },
    template_title_map: {
      it: null,
      en: null,
    },
    product_type: 'siae_abbonamento_libero',
    siae_domain: true,
    group_type_code: 'IND',
    current_price: 73,
    current_presales_amount: 0,
    competence_date: null,
    area_id: '647869a011b1421bf754701b',
    related_products: [],
    bank_account_id: null,
    configurable_id: '6486ef1fad9910072dc33e07',
    transit_from: null,
    transit_to: null,
    access_state_enabled: null,
    access_fiscality_executed_once: null,
    group_type: {
      id: '60ec4b037c8f3f63ae23167d',
      code: 'IND',
      description: 'Individuale',
      blame_operator_id: null,
      read_only: false,
      count_result: null,
    },
    group_type_id: '60ec4b037c8f3f63ae23167d',
    sell_limit: null,
    merch_stock: null,
    merch_max_limit: null,
    customer_merch_limit: null,
    position: null,
    salable: null,
    pdf_template_id: null,
    pdf_template_upload_snap: null,
    emission_organizer_name: null,
    emission_organizer_fiscal_code: null,
    product_images: null,
    max_number_of_assignments: null,
    profiling_category: null,
    enable_lead: null,
    enable_entrance_sms: null,
    linked_form_name: '',
    visual_description: null,
    max_tickets_for_enabled_owner: null,
    holder_email_template_map: {
      it: null,
      en: null,
    },
    invitation_email_template_map: {
      it: null,
      en: null,
    },
    skip_reservation_check_to_entrance: null,
    quantity: 2,
  },
];

export const DummyFetchedProducts = [
  {
    id: '6486ef1fad9910072dc33e08',
    code: 'SDM24_OPE_6_PVOK',
    description: 'Biglietto Operatore 6 giorno - Prevendita',
    kind: 'ridotto',
    category: [],
    status: 'enabled',
    deletable: null,
    template: 'SMM_23_E-ticket_OPERATORE_06',
    titled: true,
    area: {
      id: '647869a011b1421bf754701b',
      code: 'OPE',
      description: 'Area operatori definitiva',
      blame_operator_id: '633efa1035c7e1510d218183',
      read_only: false,
      count_result: null,
    },
    prices: [
      {
        id: '6486ef1fad9910072dc33e09',
        value: 73,
        discount: 0,
        currency: 'EUR',
        blame_operator_id: null,
        read_only: false,
        count_result: null,
        start_date: '2023-06-12',
        end_date: '2024-04-21',
        product_id: '6486ef1fad9910072dc33e08',
        channel_id: '64776ad011b1421bf7546fff',
        presales_amount: 0,
      },
    ],
    duration: null,
    capacity: 6,
    blame_operator_id: null,
    read_only: false,
    count_result: null,
    display_code: 'OP6',
    kind_special: ['operator'],
    kind_description:
      'Biglietto per gli Operatori di settore valido 6 giorni. Consente alla persona a cui è intestato un massimo di 2 ingressi in ognuno dei giorni prenotati. Prezzo di prevendita online in vigore fino al 15 Aprile (23.59 CET)',
    template_title: null,
    description_map: {
      it: 'Biglietto Operatore 6 giorno - Prevendita',
      en: '6-Day Trade Visitor Ticket - Presale',
    },
    kind_description_map: {
      it: 'Biglietto per gli Operatori di settore valido 6 giorni. Consente alla persona a cui è intestato un massimo di 2 ingressi in ognuno dei giorni prenotati. Prezzo di prevendita online in vigore fino al 15 Aprile (23.59 CET)',
      en: '6-Day Trade Ticket: Must be made out to the bearer; valid for  a maximum of 2 entries on each of the booked dates. Earlybird online ticket until 15th April (23:59 CET)',
    },
    template_title_map: {
      it: null,
      en: null,
    },
    product_type: 'siae_abbonamento_libero',
    siae_domain: true,
    group_type_code: 'IND',
    current_price: 73,
    current_presales_amount: 0,
    competence_date: null,
    area_id: '647869a011b1421bf754701b',
    related_products: [],
    bank_account_id: null,
    configurable_id: '6486ef1fad9910072dc33e07',
    transit_from: null,
    transit_to: null,
    access_state_enabled: null,
    access_fiscality_executed_once: null,
    group_type: {
      id: '60ec4b037c8f3f63ae23167d',
      code: 'IND',
      description: 'Individuale',
      blame_operator_id: null,
      read_only: false,
      count_result: null,
    },
    group_type_id: '60ec4b037c8f3f63ae23167d',
    sell_limit: null,
    merch_stock: null,
    merch_max_limit: null,
    customer_merch_limit: null,
    position: null,
    salable: null,
    pdf_template_id: null,
    pdf_template_upload_snap: null,
    emission_organizer_name: null,
    emission_organizer_fiscal_code: null,
    product_images: null,
    max_number_of_assignments: null,
    profiling_category: null,
    enable_lead: null,
    enable_entrance_sms: null,
    linked_form_name: '',
    visual_description: null,
    max_tickets_for_enabled_owner: null,
    holder_email_template_map: {
      it: null,
      en: null,
    },
    invitation_email_template_map: {
      it: null,
      en: null,
    },
    skip_reservation_check_to_entrance: null,
  },
];
export const DummyFetchedMerch = [
  {
    id: '659c1ede60616d69e4258c46',
    code: 'SDM24_CATALOGO',
    description: 'Catalogo generale 2024',
    kind: null,
    category: [],
    status: 'enabled',
    deletable: null,
    template: 'SDM23_CATALOGO',
    titled: false,
    area: {
      id: '60ecbd007c8f3f63ae231684',
      code: 'default',
      description: 'Area Default',
      blame_operator_id: null,
      read_only: false,
      count_result: null,
    },
    prices: [
      {
        id: '659c1f2860616d69e4258c47',
        value: 50,
        discount: 0,
        currency: null,
        blame_operator_id: '65705edec2487079ea0bb0ec',
        read_only: false,
        count_result: null,
        start_date: '2024-01-02',
        end_date: '2024-04-21',
        product_id: '659c1ede60616d69e4258c46',
        channel_id: '64776ad011b1421bf7546fff',
        presales_amount: 0,
      },
    ],
    duration: null,
    capacity: null,
    blame_operator_id: null,
    read_only: false,
    count_result: null,
    display_code: 'CA2',
    kind_special: ['end_user', 'operator', 'school'],
    kind_description:
      "Catalogo generale Salone del Mobile.Milano 2023: (Salone del Mobile, Salone del complemento d'arredo, Workplace 3.0, S.Project, Euroluce)",
    template_title: null,
    description_map: {
      it: 'Catalogo generale 2024',
      en: 'General catalogue 2024',
    },
    kind_description_map: {
      it: "Catalogo generale Salone del Mobile.Milano 2023: (Salone del Mobile, Salone del complemento d'arredo, Workplace 3.0, S.Project, Euroluce)",
      en: 'General catalogue 2023 Salone del Mobile.Milano: (Salone del Mobile, Furnishing accessories exhibition, Workplace 3.0, S.Project, Euroluce)',
    },
    template_title_map: {
      it: null,
      en: null,
    },
    product_type: 'merchandising',
    siae_domain: false,
    group_type_code: null,
    current_price: 50,
    current_presales_amount: 0,
    competence_date: null,
    area_id: '60ecbd007c8f3f63ae231684',
    related_products: [],
    bank_account_id: null,
    configurable_id: null,
    transit_from: null,
    transit_to: null,
    access_state_enabled: null,
    access_fiscality_executed_once: null,
    group_type: null,
    group_type_id: null,
    sell_limit: null,
    merch_stock: 999991,
    merch_max_limit: 9999999,
    customer_merch_limit: null,
    position: 1,
    salable: null,
    pdf_template_id: null,
    pdf_template_upload_snap: null,
    emission_organizer_name: null,
    emission_organizer_fiscal_code: null,
    product_images: null,
    max_number_of_assignments: null,
    profiling_category: null,
    enable_lead: null,
    enable_entrance_sms: null,
    linked_form_name: null,
    visual_description: null,
    max_tickets_for_enabled_owner: null,
    holder_email_template_map: {
      it: null,
      en: null,
    },
    invitation_email_template_map: {
      it: null,
      en: null,
    },
    skip_reservation_check_to_entrance: null,
  },
];

export const DummyTickets = [
  {
    access_status: '',
    account_holder_id: '659e9f01b7077e2be1993705',
    activated_at: '2024-01-29 10:36:10',
    amount: 73,
    annulment_date: null,
    annulment_error: null,
    assignments_counter: 0,
    blame_operator_id: '655e06c4cba64e70cb06eb3b',
    burning_operator_id: null,
    count_result: null,
    created_at: '2024-01-29 10:35:26',
    customer_snap: {
      address: null,
      city: null,
      code: '0030900001Sp5ypAAB',
      company_name: null,
      contact_email: null,
      contact_name: null,
      contact_surname: null,
      continent_code: null,
      country: 'ITA',
      district: null,
      email: 'dominic.venne@vehome.de',
      firstname: 'Dominic',
      lastname: 'Venne',
      region: null,
      zip: null,
      __typename: 'CustomerSnapDto',
    },
    deleted_at: null,
    downloaded_at: null,
    downloaded_at_for_email: '2024-01-29 10:36:14',
    duration: -1,
    emission_card: 'A0140175',
    emission_counter: 267109,
    emission_datetime: '2024-01-29 10:36:21',
    emission_error: null,
    emission_organizer_fiscal_code: '03018900245',
    emission_organizer_name: 'Federlegno Arredo Eventi S.P.A.',
    emission_preassolvimento: false,
    emission_sign: '0ABD02F5833D2F54',
    external_activated: null,
    first_used_at: null,
    id: '65b7715ef79d9c2df99c08e3',
    item_id: '65b7715cf79d9c2df99c08e1',
    last_access_date: null,
    last_exit_date: null,
    note: 'Biglietto Operatore 6 giorno - Prevendita',
    number: 'CR24LOP6AA000000037J',
    operator: {
      app: 'shop',
      blame_operator_id: null,
      channel: {
        blame_operator_id: null,
        channel_type: 'online',
        code: 'SDM_SITO',
        count_result: null,
        id: '64776ad011b1421bf7546fff',
        name: 'Sito Web',
        read_only: false,
        sell_organizer_code: '1234567890',
        show_code: 'SDM-24',
        status: 'enabled',
        __typename: 'ChannelDto',
      },
      channel_id: '64776ad011b1421bf7546fff',
      code: 'JAKALA_SHOP',
      count_result: null,
      id: '655e06c4cba64e70cb06eb3b',
      printer_code: 'ZEBRA-ALTAVILLA',
      read_only: false,
      reception: '',
      roles: ['API'],
      sales_point_code: 'SW000000',
      status: 'enabled',
      username: 'jakala-shop@operator.com',
      uuid: 'b0f2de4b-470e-4708-ae88-635f0111fa32',
      __typename: 'OperatorDto',
    },
    order_billing_method: 'cashsales',
    order_channel_snap: {
      blame_operator_id: null,
      channel_type: 'online',
      code: 'SDM_SITO',
      count_result: null,
      id: '64776ad011b1421bf7546fff',
      name: 'Sito Web',
      read_only: false,
      sell_organizer_code: '1234567890',
      show_code: 'SDM-24',
      status: 'enabled',
      __typename: 'ChannelDto',
    },
    order_customer_id: '659e9f01b7077e2be1993705',
    order_customer_type: 'end_user',
    order_id: '65b7715cf79d9c2df99c08e0',
    order_invoice: false,
    order_invoice_datetime: '2024-01-29 10:35:24',
    order_number: 'VR24AA000000123B',
    order_sell_operator: {
      app: 'shop',
      blame_operator_id: null,
      channel: {
        blame_operator_id: null,
        channel_type: 'online',
        code: 'SDM_SITO',
        count_result: null,
        id: '64776ad011b1421bf7546fff',
        name: 'Sito Web',
        read_only: false,
        sell_organizer_code: '1234567890',
        show_code: 'SDM-24',
        status: 'enabled',
        __typename: 'ChannelDto',
      },
      channel_id: '64776ad011b1421bf7546fff',
      code: 'JAKALA_SHOP',
      count_result: null,
      id: '655e06c4cba64e70cb06eb3b',
      printer_code: 'ZEBRA-ALTAVILLA',
      read_only: false,
      reception: '',
      roles: ['API'],
      sales_point_code: 'SW000000',
      status: 'enabled',
      username: 'jakala-shop@operator.com',
      uuid: 'b0f2de4b-470e-4708-ae88-635f0111fa32',
      __typename: 'OperatorDto',
    },
    owner: null,
    owner_id: '65b7715ef79d9c2df99c08e2',
    owner_snap: {
      address: null,
      blame_operator_id: null,
      city: 'Jesi',
      company: 'Nautes',
      company_email: null,
      company_name: null,
      company_type: null,
      contact: null,
      contact_name: null,
      contact_surname: null,
      continent_code: 'EU',
      count_result: null,
      country: 'ITA',
      created_at: null,
      district: 'AN',
      email: 'dominic.venne@vehome.de',
      firstname: 'Dominic',
      fiscal_code: null,
      flag_condizioni_1: null,
      flag_condizioni_2: null,
      flag_condizioni_3: null,
      flag_condizioni_4: null,
      flag_condizioni_5: null,
      flag_privacy_1: {
        code: 'B7A_GUEST_INTESTA_PRIVACY',
        date: '2024-01-29 10:35:21',
        value: true,
        version: '1',
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_10: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_11: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_12: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_13: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_14: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_15: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_2: {
        code: 'B7A_GUEST_INTESTA_PRIVACY',
        date: '2024-01-29 10:35:21',
        value: false,
        version: '1',
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_3: {
        code: 'B7A_GUEST_INTESTA_PRIVACY',
        date: '2024-01-29 10:35:21',
        value: false,
        version: '1',
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_4: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_5: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_6: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_7: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_8: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      flag_privacy_9: {
        code: null,
        date: null,
        value: null,
        version: null,
        __typename: 'PrivacyFlagDto',
      },
      gender: null,
      id: '65b7715ef79d9c2df99c08e2',
      invitation_parent_customer_company_name: null,
      invitation_parent_customer_firstname: null,
      invitation_parent_customer_id: null,
      invitation_parent_customer_lastname: null,
      is_new_assignment: null,
      lastname: 'Venne',
      license_plate: null,
      locale: 'it',
      nickname: null,
      optional_ticket_to_owner_email_template: null,
      phone: '393333333333',
      privacy_verified: null,
      read_only: false,
      region: 'Marche',
      role: null,
      role_other: null,
      sdm_firm_name: 'Nautes',
      sdm_operator_sub_type: null,
      sdm_operator_type: 'acq',
      sdm_other_role_in_company: null,
      sdm_other_type: null,
      sdm_role_in_company: '1001',
      send_ticket_to_owner: false,
      status: 'enabled',
      ticket_id: null,
      transport_model: null,
      transport_typology: null,
      university: null,
      updated_at: '2024-01-29 10:36:14',
      website: null,
      wechat_id: null,
      zip: '60035',
      __typename: 'OwnerDto',
    },
    owner_status: 'enabled',
    prepare_channel_code: 'SDM_SITO',
    prepare_channel_name: 'Sito Web',
    prepare_operator_code: 'JAKALA_SHOP',
    presales_amount: 0,
    print_locally: false,
    product: {
      access_fiscality_executed_once: null,
      access_state_enabled: null,
      area: {
        blame_operator_id: '633efa1035c7e1510d218183',
        code: 'OPE',
        count_result: null,
        description: 'Area operatori definitiva',
        id: '647869a011b1421bf754701b',
        read_only: false,
        __typename: 'AreaDto',
      },
      area_id: '647869a011b1421bf754701b',
      bank_account_id: null,
      blame_operator_id: '65a3e03e14186652cb01c64a',
      capacity: 6,
      category: [],
      code: 'SDM24_OPE_6_PVOK',
      competence_date: null,
      configurable_id: '6486ef1fad9910072dc33e07',
      count_result: null,
      current_presales_amount: null,
      current_price: null,
      customer_merch_limit: null,
      deletable: false,
      description: 'Biglietto Operatore 6 giorno - Prevendita',
      description_map: {
        en: '6-Day Trade Visitor Ticket - Presale',
        it: 'Biglietto Operatore 6 giorno - Prevendita',
        __typename: 'LanguageBundle',
      },
      display_code: 'OP6',
      duration: '',
      emission_organizer_fiscal_code: null,
      emission_organizer_name: null,
      enable_entrance_sms: false,
      enable_lead: true,
      group_type: {
        blame_operator_id: null,
        code: 'IND',
        count_result: null,
        description: 'Individuale',
        id: '60ec4b037c8f3f63ae23167d',
        read_only: false,
        __typename: 'GroupTypeDto',
      },
      group_type_code: 'IND',
      group_type_id: '60ec4b037c8f3f63ae23167d',
      holder_email_template_map: {
        en: '',
        it: '',
        __typename: 'LanguageBundle',
      },
      id: '6486ef1fad9910072dc33e08',
      invitation_email_template_map: {
        en: '',
        it: '',
        __typename: 'LanguageBundle',
      },
      kind: 'ridotto',
      kind_description:
        'Biglietto per gli Operatori di settore valido 6 giorni. Consente alla persona a cui è intestato un massimo di 2 ingressi in ognuno dei giorni prenotati. Prezzo di prevendita online in vigore fino al 15 Aprile (23.59 CET)',
      kind_description_map: {
        en: '6-Day Trade Ticket: Must be made out to the bearer; valid for  a maximum of 2 entries on each of the booked dates. Earlybird online ticket until 15th April (23:59 CET)',
        it: 'Biglietto per gli Operatori di settore valido 6 giorni. Consente alla persona a cui è intestato un massimo di 2 ingressi in ognuno dei giorni prenotati. Prezzo di prevendita online in vigore fino al 15 Aprile (23.59 CET)',
        __typename: 'LanguageBundle',
      },
      kind_special: ['operator'],
      linked_form_name: '',
      max_number_of_assignments: 0,
      max_tickets_for_enabled_owner: null,
      merch_max_limit: null,
      merch_stock: null,
      pdf_template_id: '63f8e76646b45e7468893ddc',
      pdf_template_upload_snap: {
        download_url:
          'https://storage.googleapis.com/dticketing-sdm-2023-static/templates/sdm-stag/63f8e76646b45e7468893ddc/63f8e76646b45e7468893ddc.png',
        has_got_logo: true,
        is_parent: false,
        is_siae: true,
        parent_template: 'PARENT_SIAE',
        __typename: 'PdfTemplateUploadSnapDto',
      },
      position: null,
      prices: [
        {
          blame_operator_id: null,
          channel_id: '64776ad011b1421bf7546fff',
          count_result: null,
          currency: 'EUR',
          discount: 0,
          end_date: '2024-04-21',
          id: '6486ef1fad9910072dc33e09',
          presales_amount: 0,
          product_id: '6486ef1fad9910072dc33e08',
          read_only: false,
          start_date: '2023-06-12',
          value: 73,
          __typename: 'PriceDto',
        },
      ],
      product_images: null,
      product_type: 'siae_abbonamento_libero',
      profiling_category: 'OPE',
      read_only: false,
      related_products: [],
      salable: true,
      sell_limit: null,
      siae_domain: true,
      skip_reservation_check_to_entrance: true,
      status: 'enabled',
      template: 'SMM_23_E-ticket_OPERATORE_06',
      template_title: '',
      template_title_map: {
        en: '',
        it: '',
        __typename: 'LanguageBundle',
      },
      titled: true,
      transit_from: null,
      transit_to: null,
      visual_description: 'Operatore 6 - Prevendita',
      __typename: 'ProductDto',
    },
    product_id: '6486ef1fad9910072dc33e08',
    product_snap: {
      area_code: 'OPE',
      area_description: 'Area operatori definitiva',
      category: [],
      code: 'SDM24_OPE_6_PVOK',
      competence_date: null,
      description: 'Biglietto Operatore 6 giorno - Prevendita',
      description_en: '6-Day Trade Visitor Ticket - Presale',
      display_code: 'OP6',
      enable_entrance_sms: false,
      enable_lead: true,
      reservable: 'IND',
      kind: 'ridotto',
      kind_description:
        'Biglietto per gli Operatori di settore valido 6 giorni. Consente alla persona a cui è intestato un massimo di 2 ingressi in ognuno dei giorni prenotati. Prezzo di prevendita online in vigore fino al 15 Aprile (23.59 CET)',
      kind_description_en:
        '6-Day Trade Ticket: Must be made out to the bearer; valid for  a maximum of 2 entries on each of the booked dates. Earlybird online ticket until 15th April (23:59 CET)',
      kind_special: ['operator'],
      merch_stock: null,
      product_type: 'siae_abbonamento_libero',
      profiling_category: 'OPE',
      siae_domain: true,
      template: 'SMM_23_E-ticket_OPERATORE_06',
      template_title: '',
      titled: true,
      visual_description: 'Operatore 6 - Prevendita',
      __typename: 'TicketProductDto',
    },
    read_only: false,
    related_ticket_id: null,
    reservation: null,
    reservation_id: '65b7715ff79d9c2df99c08e5',
    reservation_snap: {
      blame_operator_id: null,
      closed_at: '2024-01-29 10:36:10',
      count_result: null,
      id: null,
      number: 'RS24AA000000132C',
      read_only: null,
      reservation_dates: [
        {
          group_id: '64786b9711b1421bf754701f',
          reservation_start_date_time: '2024-04-16 00:00:00',
          __typename: 'ReservationDatesDto',
        },
        {
          group_id: '64786b9711b1421bf7547021',
          reservation_start_date_time: '2024-04-17 00:00:00',
          __typename: 'ReservationDatesDto',
        },
      ],
      reserved_at: '2024-01-29 10:35:27',
      status: 'confirmed',
      __typename: 'ReservationDto',
    },
    reservation_status: 'confirmed',
    secure_code: '57003',
    siae_data: {
      emitting_system_code: 'P0002847',
      event_name: null,
      event_site_name: null,
      event_start_date: null,
      event_type_code: '70',
      holder_fiscal_code: 'GTTLNZ72P28A459A',
      pass_type: 'A',
      product_capacity: 6,
      product_expiration: '2024-04-21',
      sector_name: 'UN - posto unico',
      subscription_code: 'S2400099',
      subscription_serial_number: '13',
      ticket_type_description: 'Ridotto L9 - Ridotto Online EB 6',
      vault_amount: 7300,
      vault_figure_amount: null,
      vault_presales_amount: 0,
      __typename: 'SiaeDataDto',
    },
    status: 'valid',
    status_prior_annulment_request: null,
    ticket_type: 'DD',
    updated_at: '2024-01-29 10:36:14',
    wanted_info: null,
    __typename: 'TicketDto',
  },
  {
    access_status: '',
    account_holder_id: '659e9f01b7077e2be1993705',
    activated_at: '2024-01-29 10:36:04',
    amount: 50,
    annulment_date: null,
    annulment_error: null,
    assignments_counter: 0,
    blame_operator_id: '633efa1035c7e1510d218183',
    burning_operator_id: null,
    count_result: null,
    created_at: '2024-01-29 10:35:27',
    customer_snap: {
      address: null,
      city: null,
      code: '0030900001Sp5ypAAB',
      company_name: null,
      contact_email: null,
      contact_name: null,
      contact_surname: null,
      continent_code: null,
      country: 'ITA',
      district: null,
      email: 'dominic.venne@vehome.de',
      firstname: 'Dominic',
      lastname: 'Venne',
      region: null,
      zip: null,
      __typename: 'CustomerSnapDto',
    },
    deleted_at: null,
    downloaded_at: null,
    downloaded_at_for_email: null,
    duration: -1,
    emission_card: null,
    emission_counter: null,
    emission_datetime: '2024-01-29 10:36:04',
    emission_error: null,
    emission_organizer_fiscal_code: null,
    emission_organizer_name: null,
    emission_preassolvimento: null,
    emission_sign: null,
    external_activated: null,
    first_used_at: null,
    id: '65b7715ff79d9c2df99c08e7',
    item_id: '65b7715ff79d9c2df99c08e6',
    last_access_date: null,
    last_exit_date: null,
    note: 'Catalogo generale 2024',
    number: 'TK24MCA2AA000000015L',
    operator: {
      app: 'desk-admin',
      blame_operator_id: '633efa1035c7e1510d218183',
      channel: {
        blame_operator_id: null,
        channel_type: 'ticketing',
        code: 'SDM_CASSA',
        count_result: null,
        id: '6584610568338c4c3f1b0e4c',
        name: 'Cassa 2024',
        read_only: false,
        sell_organizer_code: '1234567890',
        show_code: 'SDM-24',
        status: 'enabled',
        __typename: 'ChannelDto',
      },
      channel_id: '6584610568338c4c3f1b0e4c',
      code: 'DESK',
      count_result: null,
      id: '633efa1035c7e1510d218183',
      printer_code: 'ZEBRA-ALTAVILLA',
      read_only: false,
      reception: '',
      roles: ['admin'],
      sales_point_code: 'PV000000',
      status: 'enabled',
      username: 'desk@develon.com ',
      uuid: '911a8690-83e7-4873-b1ae-b7e77109da31',
      __typename: 'OperatorDto',
    },
    order_billing_method: 'cashsales',
    order_channel_snap: {
      blame_operator_id: null,
      channel_type: 'online',
      code: 'SDM_SITO',
      count_result: null,
      id: '64776ad011b1421bf7546fff',
      name: 'Sito Web',
      read_only: false,
      sell_organizer_code: '1234567890',
      show_code: 'SDM-24',
      status: 'enabled',
      __typename: 'ChannelDto',
    },
    order_customer_id: '659e9f01b7077e2be1993705',
    order_customer_type: 'end_user',
    order_id: '65b7715cf79d9c2df99c08e0',
    order_invoice: false,
    order_invoice_datetime: '2024-01-29 10:35:24',
    order_number: 'VR24AA000000123B',
    order_sell_operator: {
      app: 'shop',
      blame_operator_id: null,
      channel: {
        blame_operator_id: null,
        channel_type: 'online',
        code: 'SDM_SITO',
        count_result: null,
        id: '64776ad011b1421bf7546fff',
        name: 'Sito Web',
        read_only: false,
        sell_organizer_code: '1234567890',
        show_code: 'SDM-24',
        status: 'enabled',
        __typename: 'ChannelDto',
      },
      channel_id: '64776ad011b1421bf7546fff',
      code: 'JAKALA_SHOP',
      count_result: null,
      id: '655e06c4cba64e70cb06eb3b',
      printer_code: 'ZEBRA-ALTAVILLA',
      read_only: false,
      reception: '',
      roles: ['API'],
      sales_point_code: 'SW000000',
      status: 'enabled',
      username: 'jakala-shop@operator.com',
      uuid: 'b0f2de4b-470e-4708-ae88-635f0111fa32',
      __typename: 'OperatorDto',
    },
    owner: null,
    owner_id: null,
    owner_snap: null,
    owner_status: null,
    prepare_channel_code: 'SDM_SITO',
    prepare_channel_name: 'Sito Web',
    prepare_operator_code: 'JAKALA_SHOP',
    presales_amount: 0,
    print_locally: false,
    product: {
      access_fiscality_executed_once: null,
      access_state_enabled: null,
      area: {
        blame_operator_id: null,
        code: 'default',
        count_result: null,
        description: 'Area Default',
        id: '60ecbd007c8f3f63ae231684',
        read_only: false,
        __typename: 'AreaDto',
      },
      area_id: '60ecbd007c8f3f63ae231684',
      bank_account_id: null,
      blame_operator_id: '65705edec2487079ea0bb0ec',
      capacity: null,
      category: [],
      code: 'SDM24_CATALOGO',
      competence_date: null,
      configurable_id: null,
      count_result: null,
      current_presales_amount: null,
      current_price: null,
      customer_merch_limit: null,
      deletable: false,
      description: 'Catalogo generale 2024',
      description_map: {
        en: 'General catalogue 2024',
        it: 'Catalogo generale 2024',
        __typename: 'LanguageBundle',
      },
      display_code: 'CA2',
      duration: null,
      emission_organizer_fiscal_code: null,
      emission_organizer_name: null,
      enable_entrance_sms: false,
      enable_lead: false,
      group_type: null,
      group_type_code: null,
      group_type_id: null,
      holder_email_template_map: {
        en: null,
        it: null,
        __typename: 'LanguageBundle',
      },
      id: '659c1ede60616d69e4258c46',
      invitation_email_template_map: {
        en: null,
        it: null,
        __typename: 'LanguageBundle',
      },
      kind: null,
      kind_description:
        "Catalogo generale Salone del Mobile.Milano 2023: (Salone del Mobile, Salone del complemento d'arredo, Workplace 3.0, S.Project, Euroluce)",
      kind_description_map: {
        en: 'General catalogue 2023 Salone del Mobile.Milano: (Salone del Mobile, Furnishing accessories exhibition, Workplace 3.0, S.Project, Euroluce)',
        it: "Catalogo generale Salone del Mobile.Milano 2023: (Salone del Mobile, Salone del complemento d'arredo, Workplace 3.0, S.Project, Euroluce)",
        __typename: 'LanguageBundle',
      },
      kind_special: ['end_user', 'operator', 'school'],
      linked_form_name: null,
      max_number_of_assignments: null,
      max_tickets_for_enabled_owner: null,
      merch_max_limit: 9999999,
      merch_stock: 999999,
      pdf_template_id: '6405b85c96aa90372dac1d3c',
      pdf_template_upload_snap: {
        download_url:
          'https://storage.googleapis.com/dticketing-sdm-2023-static/templates/sdm-prod/6405b85c96aa90372dac1d3c/6405b85c96aa90372dac1d3c.png',
        has_got_logo: false,
        is_parent: false,
        is_siae: false,
        parent_template: 'PARENT_NON_SIAE_SPONSOR_MERCHANDISE',
        __typename: 'PdfTemplateUploadSnapDto',
      },
      position: 1,
      prices: [
        {
          blame_operator_id: '65705edec2487079ea0bb0ec',
          channel_id: '64776ad011b1421bf7546fff',
          count_result: null,
          currency: null,
          discount: 0,
          end_date: '2024-04-21',
          id: '659c1f2860616d69e4258c47',
          presales_amount: 0,
          product_id: '659c1ede60616d69e4258c46',
          read_only: false,
          start_date: '2024-01-02',
          value: 50,
          __typename: 'PriceDto',
        },
      ],
      product_images: null,
      product_type: 'merchandising',
      profiling_category: 'PUB',
      read_only: false,
      related_products: [],
      salable: true,
      sell_limit: null,
      siae_domain: false,
      skip_reservation_check_to_entrance: null,
      status: 'enabled',
      template: 'SDM23_CATALOGO',
      template_title: '',
      template_title_map: {
        en: '',
        it: '',
        __typename: 'LanguageBundle',
      },
      titled: false,
      transit_from: null,
      transit_to: null,
      visual_description: 'Catalogo generale 2024',
      __typename: 'ProductDto',
    },
    product_id: '659c1ede60616d69e4258c46',
    product_snap: {
      area_code: 'default',
      area_description: 'Area Default',
      category: [],
      code: 'SDM24_CATALOGO',
      competence_date: null,
      description: 'Catalogo generale 2024',
      description_en: 'General catalogue 2024',
      display_code: 'CA2',
      enable_entrance_sms: false,
      enable_lead: false,
      reservable: null,
      kind: null,
      kind_description:
        "Catalogo generale Salone del Mobile.Milano 2023: (Salone del Mobile, Salone del complemento d'arredo, Workplace 3.0, S.Project, Euroluce)",
      kind_description_en:
        'General catalogue 2023 Salone del Mobile.Milano: (Salone del Mobile, Furnishing accessories exhibition, Workplace 3.0, S.Project, Euroluce)',
      kind_special: ['end_user', 'operator', 'school'],
      merch_stock: 999999,
      product_type: 'merchandising',
      profiling_category: 'PUB',
      siae_domain: false,
      template: 'SDM23_CATALOGO',
      template_title: '',
      titled: false,
      visual_description: 'Catalogo generale 2024',
      __typename: 'TicketProductDto',
    },
    read_only: false,
    related_ticket_id: null,
    reservation: null,
    reservation_id: null,
    reservation_snap: null,
    reservation_status: null,
    secure_code: '96351',
    siae_data: {
      emitting_system_code: null,
      event_name: null,
      event_site_name: null,
      event_start_date: null,
      event_type_code: null,
      holder_fiscal_code: null,
      pass_type: null,
      product_capacity: null,
      product_expiration: null,
      sector_name: null,
      subscription_code: null,
      subscription_serial_number: null,
      ticket_type_description: null,
      vault_amount: null,
      vault_figure_amount: null,
      vault_presales_amount: null,
      __typename: 'SiaeDataDto',
    },
    status: 'valid',
    status_prior_annulment_request: null,
    ticket_type: 'DD',
    updated_at: '2024-01-29 10:36:04',
    wanted_info: null,
    __typename: 'TicketDto',
  },
  {
    access_status: '',
    account_holder_id: '659e9f01b7077e2be1993705',
    activated_at: '2024-01-29 10:36:04',
    amount: 50,
    annulment_date: null,
    annulment_error: null,
    assignments_counter: 0,
    blame_operator_id: '633efa1035c7e1510d218183',
    burning_operator_id: null,
    count_result: null,
    created_at: '2024-01-29 10:35:27',
    customer_snap: {
      address: null,
      city: null,
      code: '0030900001Sp5ypAAB',
      company_name: null,
      contact_email: null,
      contact_name: null,
      contact_surname: null,
      continent_code: null,
      country: 'ITA',
      district: null,
      email: 'dominic.venne@vehome.de',
      firstname: 'Dominic',
      lastname: 'Venne',
      region: null,
      zip: null,
      __typename: 'CustomerSnapDto',
    },
    deleted_at: null,
    downloaded_at: null,
    downloaded_at_for_email: null,
    duration: -1,
    emission_card: null,
    emission_counter: null,
    emission_datetime: '2024-01-29 10:36:04',
    emission_error: null,
    emission_organizer_fiscal_code: null,
    emission_organizer_name: null,
    emission_preassolvimento: null,
    emission_sign: null,
    external_activated: null,
    first_used_at: null,
    id: '65b7715ff79d9c2df99c08e8',
    item_id: '65b7715ff79d9c2df99c08e6',
    last_access_date: null,
    last_exit_date: null,
    note: 'Catalogo generale 2024',
    number: 'TK24MCA2AA000000016M',
    operator: {
      app: 'desk-admin',
      blame_operator_id: '633efa1035c7e1510d218183',
      channel: {
        blame_operator_id: null,
        channel_type: 'ticketing',
        code: 'SDM_CASSA',
        count_result: null,
        id: '6584610568338c4c3f1b0e4c',
        name: 'Cassa 2024',
        read_only: false,
        sell_organizer_code: '1234567890',
        show_code: 'SDM-24',
        status: 'enabled',
        __typename: 'ChannelDto',
      },
      channel_id: '6584610568338c4c3f1b0e4c',
      code: 'DESK',
      count_result: null,
      id: '633efa1035c7e1510d218183',
      printer_code: 'ZEBRA-ALTAVILLA',
      read_only: false,
      reception: '',
      roles: ['admin'],
      sales_point_code: 'PV000000',
      status: 'enabled',
      username: 'desk@develon.com ',
      uuid: '911a8690-83e7-4873-b1ae-b7e77109da31',
      __typename: 'OperatorDto',
    },
    order_billing_method: 'cashsales',
    order_channel_snap: {
      blame_operator_id: null,
      channel_type: 'online',
      code: 'SDM_SITO',
      count_result: null,
      id: '64776ad011b1421bf7546fff',
      name: 'Sito Web',
      read_only: false,
      sell_organizer_code: '1234567890',
      show_code: 'SDM-24',
      status: 'enabled',
      __typename: 'ChannelDto',
    },
    order_customer_id: '659e9f01b7077e2be1993705',
    order_customer_type: 'end_user',
    order_id: '65b7715cf79d9c2df99c08e0',
    order_invoice: false,
    order_invoice_datetime: '2024-01-29 10:35:24',
    order_number: 'VR24AA000000123B',
    order_sell_operator: {
      app: 'shop',
      blame_operator_id: null,
      channel: {
        blame_operator_id: null,
        channel_type: 'online',
        code: 'SDM_SITO',
        count_result: null,
        id: '64776ad011b1421bf7546fff',
        name: 'Sito Web',
        read_only: false,
        sell_organizer_code: '1234567890',
        show_code: 'SDM-24',
        status: 'enabled',
        __typename: 'ChannelDto',
      },
      channel_id: '64776ad011b1421bf7546fff',
      code: 'JAKALA_SHOP',
      count_result: null,
      id: '655e06c4cba64e70cb06eb3b',
      printer_code: 'ZEBRA-ALTAVILLA',
      read_only: false,
      reception: '',
      roles: ['API'],
      sales_point_code: 'SW000000',
      status: 'enabled',
      username: 'jakala-shop@operator.com',
      uuid: 'b0f2de4b-470e-4708-ae88-635f0111fa32',
      __typename: 'OperatorDto',
    },
    owner: null,
    owner_id: null,
    owner_snap: null,
    owner_status: null,
    prepare_channel_code: 'SDM_SITO',
    prepare_channel_name: 'Sito Web',
    prepare_operator_code: 'JAKALA_SHOP',
    presales_amount: 0,
    print_locally: false,
    product: {
      access_fiscality_executed_once: null,
      access_state_enabled: null,
      area: {
        blame_operator_id: null,
        code: 'default',
        count_result: null,
        description: 'Area Default',
        id: '60ecbd007c8f3f63ae231684',
        read_only: false,
        __typename: 'AreaDto',
      },
      area_id: '60ecbd007c8f3f63ae231684',
      bank_account_id: null,
      blame_operator_id: '65705edec2487079ea0bb0ec',
      capacity: null,
      category: [],
      code: 'SDM24_CATALOGO',
      competence_date: null,
      configurable_id: null,
      count_result: null,
      current_presales_amount: null,
      current_price: null,
      customer_merch_limit: null,
      deletable: false,
      description: 'Catalogo generale 2024',
      description_map: {
        en: 'General catalogue 2024',
        it: 'Catalogo generale 2024',
        __typename: 'LanguageBundle',
      },
      display_code: 'CA2',
      duration: null,
      emission_organizer_fiscal_code: null,
      emission_organizer_name: null,
      enable_entrance_sms: false,
      enable_lead: false,
      group_type: null,
      group_type_code: null,
      group_type_id: null,
      holder_email_template_map: {
        en: null,
        it: null,
        __typename: 'LanguageBundle',
      },
      id: '659c1ede60616d69e4258c46',
      invitation_email_template_map: {
        en: null,
        it: null,
        __typename: 'LanguageBundle',
      },
      kind: null,
      kind_description:
        "Catalogo generale Salone del Mobile.Milano 2023: (Salone del Mobile, Salone del complemento d'arredo, Workplace 3.0, S.Project, Euroluce)",
      kind_description_map: {
        en: 'General catalogue 2023 Salone del Mobile.Milano: (Salone del Mobile, Furnishing accessories exhibition, Workplace 3.0, S.Project, Euroluce)',
        it: "Catalogo generale Salone del Mobile.Milano 2023: (Salone del Mobile, Salone del complemento d'arredo, Workplace 3.0, S.Project, Euroluce)",
        __typename: 'LanguageBundle',
      },
      kind_special: ['end_user', 'operator', 'school'],
      linked_form_name: null,
      max_number_of_assignments: null,
      max_tickets_for_enabled_owner: null,
      merch_max_limit: 9999999,
      merch_stock: 999999,
      pdf_template_id: '6405b85c96aa90372dac1d3c',
      pdf_template_upload_snap: {
        download_url:
          'https://storage.googleapis.com/dticketing-sdm-2023-static/templates/sdm-prod/6405b85c96aa90372dac1d3c/6405b85c96aa90372dac1d3c.png',
        has_got_logo: false,
        is_parent: false,
        is_siae: false,
        parent_template: 'PARENT_NON_SIAE_SPONSOR_MERCHANDISE',
        __typename: 'PdfTemplateUploadSnapDto',
      },
      position: 1,
      prices: [
        {
          blame_operator_id: '65705edec2487079ea0bb0ec',
          channel_id: '64776ad011b1421bf7546fff',
          count_result: null,
          currency: null,
          discount: 0,
          end_date: '2024-04-21',
          id: '659c1f2860616d69e4258c47',
          presales_amount: 0,
          product_id: '659c1ede60616d69e4258c46',
          read_only: false,
          start_date: '2024-01-02',
          value: 50,
          __typename: 'PriceDto',
        },
      ],
      product_images: null,
      product_type: 'merchandising',
      profiling_category: 'PUB',
      read_only: false,
      related_products: [],
      salable: true,
      sell_limit: null,
      siae_domain: false,
      skip_reservation_check_to_entrance: null,
      status: 'enabled',
      template: 'SDM23_CATALOGO',
      template_title: '',
      template_title_map: {
        en: '',
        it: '',
        __typename: 'LanguageBundle',
      },
      titled: false,
      transit_from: null,
      transit_to: null,
      visual_description: 'Catalogo generale 2024',
      __typename: 'ProductDto',
    },
    product_id: '659c1ede60616d69e4258c46',
    product_snap: {
      area_code: 'default',
      area_description: 'Area Default',
      category: [],
      code: 'SDM24_CATALOGO',
      competence_date: null,
      description: 'Catalogo generale 2024',
      description_en: 'General catalogue 2024',
      display_code: 'CA2',
      enable_entrance_sms: false,
      enable_lead: false,
      reservable: null,
      kind: null,
      kind_description:
        "Catalogo generale Salone del Mobile.Milano 2023: (Salone del Mobile, Salone del complemento d'arredo, Workplace 3.0, S.Project, Euroluce)",
      kind_description_en:
        'General catalogue 2023 Salone del Mobile.Milano: (Salone del Mobile, Furnishing accessories exhibition, Workplace 3.0, S.Project, Euroluce)',
      kind_special: ['end_user', 'operator', 'school'],
      merch_stock: 999999,
      product_type: 'merchandising',
      profiling_category: 'PUB',
      siae_domain: false,
      template: 'SDM23_CATALOGO',
      template_title: '',
      titled: false,
      visual_description: 'Catalogo generale 2024',
      __typename: 'TicketProductDto',
    },
    read_only: false,
    related_ticket_id: null,
    reservation: null,
    reservation_id: null,
    reservation_snap: null,
    reservation_status: null,
    secure_code: '99004',
    siae_data: {
      emitting_system_code: null,
      event_name: null,
      event_site_name: null,
      event_start_date: null,
      event_type_code: null,
      holder_fiscal_code: null,
      pass_type: null,
      product_capacity: null,
      product_expiration: null,
      sector_name: null,
      subscription_code: null,
      subscription_serial_number: null,
      ticket_type_description: null,
      vault_amount: null,
      vault_figure_amount: null,
      vault_presales_amount: null,
      __typename: 'SiaeDataDto',
    },
    status: 'valid',
    status_prior_annulment_request: null,
    ticket_type: 'DD',
    updated_at: '2024-01-29 10:36:04',
    wanted_info: null,
    __typename: 'TicketDto',
  },
];
